import { Checkbox, Chip, FormControlLabel, FormGroup, MenuItem, Select, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, runInAction, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';

import ErrorUtil from '@/util/ErrorUtil';

import '../../css/botao.css';
import AutoComplete from '../AutoComplete';
import ReactComponent from '../ReactComponent';
import IconeLimpar from './icones/IconeLimpar';

class FiltroSelecao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            filtro: computed,
            carregando: computed,
            valorFiltro: computed,
            valorSelect: computed,
            valorSelectMultiplo: computed,
            opcoes: computed,
            alterarValorFiltro: action,
            handleChangeSelect: action,
            handleChangeSelectMultiplo: action,
            handleClickCheckbox: action,
            handleClickLimpar: action,
            callbackAutoComplete: action,
            isAutoComplete: computed,
            renderComponentes: computed,
            renderAutoComplete: computed,
            renderSelect: computed,
            renderOpcoesSelect: computed,
            renderCheckbox: computed
        });

        runInAction(() => (this.filtro.carregando = true));
    }

    async componentDidMount() {
        try {
            await this.filtro.carregarDadosComplementares();
        } catch (error) {
            console.error(`Falha na inicialização do componente FiltroSelecao: ${ErrorUtil.getMensagemErro(error)}`);
            throw new Error('Falha na inicialização do componente FiltroSelecao', { cause: error });
        } finally {
            setTimeout(() => runInAction(() => (this.filtro.carregando = false)), 1);
        }
    }

    get filtro() {
        return this.store.filtros[this.observableProps.idFiltro];
    }

    get carregando() {
        return this.filtro && this.filtro.carregando;
    }

    get valorFiltro() {
        let valor = this.filtro.valor;
        return valor ? valor : '';
    }

    get valorSelect() {
        let valor = this.filtro.valor;
        return valor ? JSON.stringify(valor) : '';
    }

    get valorSelectMultiplo() {
        let valor = this.filtro.valor;
        return valor ? valor.slice().map((vlr) => JSON.stringify(vlr)) : [];
    }

    get opcoes() {
        if (this.filtro.opcoesSelect) {
            return this.filtro.opcoesSelect;
        }
        let opcoes = [];
        if (!this.carregando && !this.filtro.carregandoDadosComplementares) {
            let processos = this.isAutoComplete ? this.store.processosFiltrados : this.store.processosSessao;
            let valorOpcao;
            for (const registro of processos) {
                valorOpcao = this.filtro.getValorOpcao(registro);
                if (valorOpcao) {
                    if (Array.isArray(toJS(valorOpcao))) {
                        valorOpcao.forEach((valorArray) => this.adicionarOpcaoUnica(opcoes, valorArray, registro));
                    } else {
                        this.adicionarOpcaoUnica(opcoes, valorOpcao, registro);
                    }
                }
            }
            if (this.filtro.exibeTotalizadores) {
                this.calcularTotalizadores(opcoes);
            }
            opcoes.sort(this.filtro.sort);
        }
        return opcoes;
    }

    calcularTotalizadores(opcoes) {
        opcoes.forEach((opcao) => {
            opcao.totalizadores = [];
            this.store.opcoesProcessosEmExibicao.forEach((opcaoProcessos) => {
                opcao.totalizadores.push({
                    descricao: opcaoProcessos.descricao,
                    quantidadeFiltrados: this.filtro._filtrarProcessos(
                        opcaoProcessos.funcaoProcessosFiltrados(),
                        opcao.valor
                    ).length
                });
            });
            if (this.isAutoComplete) {
                opcao.textoSecundario =
                    '(' +
                    opcao.totalizadores
                        .map((totalizador) => totalizador.descricao + ': ' + totalizador.quantidadeFiltrados)
                        .join('; ') +
                    ')';
            }
        });
    }

    adicionarOpcaoUnica(opcoes, valor, registro) {
        if (opcoes.findIndex((opcao) => this.filtro.equals(opcao.valor, valor)) === -1) {
            opcoes.push({
                texto: (this.filtro.getDescricao(valor) || '').trim(),
                icone: this.filtro.getIconeOpcao(registro, valor),
                cor: this.filtro.getCorOpcao(registro, valor),
                valor: valor
            });
        }
    }

    alterarValorFiltro(valor) {
        this.store.alterandoValorFiltro = true;
        setTimeout(
            () =>
                runInAction(() => {
                    this.filtro.valor = valor;
                    this.store.alterandoValorFiltro = false;
                }),
            10
        );
    }

    handleChangeSelect = (event) => {
        let valor = JSON.parse(event.target.value);
        let opcaoSelecionada = this.opcoes.find((opcao) => opcao.valor === valor);
        if (opcaoSelecionada) {
            this.alterarValorFiltro(opcaoSelecionada.valor);
        } else {
            this.alterarValorFiltro(undefined);
        }
    };

    handleChangeSelectMultiplo = (event) => {
        let valor = event.target.value.map((vlr) => JSON.parse(vlr));
        this.alterarValorFiltro(valor.filter((vlr) => vlr));
    };

    handleClickCheckbox = (opcao) => {
        if (this.filtro.valor === opcao.valor) {
            this.alterarValorFiltro(undefined);
        } else {
            this.alterarValorFiltro(opcao.valor);
        }
    };

    handleClickLimpar = () => {
        this.alterarValorFiltro(undefined);
    };

    callbackAutoComplete = (option) => {
        this.alterarValorFiltro(option ? option.valor : undefined);
    };

    get isAutoComplete() {
        return this.filtro.exibicao === 'autocomplete';
    }

    render() {
        return (
            <div>
                {this.filtro && !this.filtro.ocultaFiltro ? (
                    <div style={{ marginTop: '7px' }}>
                        <Typography
                            variant="subtitle2"
                            color="inherit"
                            style={{ marginRight: '10px' }}
                        >
                            {this.filtro.label}
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {this.filtro.carregandoDadosComplementares
                                ? this.filtro.renderCarregando()
                                : this.renderComponentes}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    get renderComponentes() {
        if (this.opcoes.length > 0) {
            return (
                <Fragment>
                    {this.filtro.exibicao === 'select' && this.renderSelect}
                    {this.isAutoComplete && this.renderAutoComplete}
                    {this.filtro.exibicao === 'checkbox' && this.renderCheckbox}
                </Fragment>
            );
        }
        return (
            <Typography
                variant="subtitle1"
                style={{ minHeight: '40px', marginBottom: '8px' }}
            >
                {'Não há processos com ' +
                    this.filtro.label +
                    (this.store.existeFiltroAtivo ? ' para os filtros selecionados' : '')}
            </Typography>
        );
    }

    get renderAutoComplete() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexGrow: 1,
                    alignItems: 'baseline',
                    marginBottom: '8px',
                    marginRight: '8px'
                }}
            >
                <AutoComplete
                    apresentarTextoSecundario={this.filtro.exibeTotalizadores}
                    value={this.filtro.getDescricao(this.filtro.valor) || null}
                    options={this.opcoes}
                    onChange={this.callbackAutoComplete}
                    loading={this.filtro.carregandoDadosComplementares}
                />
            </div>
        );
    }

    get renderSelect() {
        return (
            <Fragment>
                {this.filtro.selecaoMultipla ? (
                    <Select
                        multiple
                        SelectDisplayProps={{ id: 'select' + this.filtro.idFiltro }}
                        style={{ minWidth: '120px', marginBottom: '15px' }}
                        value={this.valorSelectMultiplo}
                        onChange={this.handleChangeSelectMultiplo}
                        renderValue={(selected) => (
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                {selected.map((value) => (
                                    <Chip
                                        key={this.nextKey}
                                        label={this.filtro.getDescricao(JSON.parse(value))}
                                    />
                                ))}
                            </div>
                        )}
                    >
                        {this.renderOpcoesSelect}
                    </Select>
                ) : (
                    <Select
                        value={this.valorSelect}
                        onChange={this.handleChangeSelect}
                        style={{ minWidth: '120px', marginBottom: '15px' }}
                    >
                        {this.renderOpcoesSelect}
                    </Select>
                )}
                <Tooltip
                    title="Limpar campo"
                    placement="top"
                >
                    <span>
                        <IconeLimpar
                            style={{ cursor: 'pointer', margin: '0px 10px 15px', minWidth: '24px' }}
                            onClick={this.handleClickLimpar}
                        />
                    </span>
                </Tooltip>
            </Fragment>
        );
    }

    get renderOpcoesSelect() {
        return this.opcoes.map((opcao) => (
            <MenuItem
                key={this.nextKey}
                value={JSON.stringify(opcao.valor)}
                style={{ color: opcao.cor, justifyContent: 'space-between' }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <div style={{ fontWeight: 'bold' }}>{opcao.texto}</div>
                    {this.renderTotalizadores(opcao)}
                </div>
                {this.renderIcone(opcao)}
            </MenuItem>
        ));
    }

    renderIcone = (opcao) => {
        return opcao.icone ? <span style={{ display: 'flex', margin: '0px 12px 0px 30px' }}>{opcao.icone}</span> : null;
    };

    get renderCheckbox() {
        return (
            <FormGroup row>
                {this.opcoes.map((opcao) => (
                    <FormControlLabel
                        key={this.nextKey}
                        style={{ width: '330px' }}
                        label={
                            <div style={{ fontSize: '0.9rem' }}>
                                <div style={{ fontWeight: 'bold' }}>{opcao.texto}</div>
                                {this.renderTotalizadores(opcao)}
                            </div>
                        }
                        control={
                            <Checkbox
                                color="primary"
                                value={opcao.valor}
                                onClick={() => this.handleClickCheckbox(opcao)}
                                checked={this.valorFiltro === opcao.valor}
                            />
                        }
                    />
                ))}
            </FormGroup>
        );
    }

    renderTotalizadores(opcao) {
        return (
            this.filtro.exibeTotalizadores && (
                <div style={{ fontSize: '0.9rem' }}>
                    {' ('}
                    <Typography display="inline">
                        {opcao.totalizadores
                            .map((totalizador) => totalizador.descricao + ': ' + totalizador.quantidadeFiltrados)
                            .join('; ')}
                    </Typography>
                    {')'}
                </div>
            )
        );
    }
}

export default inject('stores')(observer(FiltroSelecao));
